// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Dropdown Component */
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

.icon-error-tracker {
  position: absolute;
  color: var(--ids-input-error-tracker-color-background, var(--ids-color-red-60));
  top: 0;
  pointer-events: none;
}
.icon-error-tracker[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator {
  position: absolute;
  top: 0;
  pointer-events: none;
}
.icon-field-indicator[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator-info {
  display: var(--ids-field-indicator-info-visibility, flex);
  align-items: center;
  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));
  cursor: pointer;
  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);
}

.field-indicator-neutral {
  --ids-field-indicator-icon-color: var(--ids-color-accent-neutral-weak);
}
.field-indicator-neutral .icon-field-indicator {
  color: var(--ids-color-accent-neutral-weak);
}

.field-indicator-info {
  --ids-field-indicator-icon-color: var(--ids-color-info-default);
}
.field-indicator-info .icon-field-indicator {
  color: var(--ids-color-info-default);
}

.field-indicator-success {
  --ids-field-indicator-icon-color: var(--ids-color-success-default);
}
.field-indicator-success .icon-field-indicator {
  color: var(--ids-color-success-default);
}

.field-indicator-caution {
  --ids-field-indicator-icon-color: var(--ids-color-caution-default);
}
.field-indicator-caution .icon-field-indicator {
  color: var(--ids-color-caution-default);
}

.field-indicator-warning {
  --ids-field-indicator-icon-color: var(--ids-color-warning-default);
}
.field-indicator-warning .icon-field-indicator {
  color: var(--ids-color-warning-default);
}

.field-indicator-error {
  --ids-field-indicator-icon-color: var(--ids-color-error-default);
}
.field-indicator-error .icon-field-indicator {
  color: var(--ids-color-error-default);
}

[class*=field-indicator-].has-focus .icon-field-indicator-info {
  display: none;
}

:host {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);
  display: block;
}
:host .ids-dropdown {
  display: inline-block;
  max-width: 100%;
  width: var(--ids-box-dropdown-width, auto);
}

:host([field-indicator]) {
  --ids-field-indicator-info-margin: 0;
}

:host([field-indicator][readonly]),
:host([field-indicator][disabled]) {
  --ids-field-indicator-info-visibility: none;
}

:host([hidden]) {
  display: none;
}

:host([label-position=inline-start]) ids-trigger-field::part(container) {
  justify-content: var(--ids-box-justify-content, flex-start);
}

ids-trigger-field[readonly-background]:not([disabled])::part(input) {
  cursor: var(--ids-cursor-pointer);
}

ids-trigger-field:not([autoselect])::part(input)::selection {
  background-color: var(--ids-color-transparent);
}

.ids-dropdown.is-open ids-trigger-field:not([autoselect])::part(input)::selection {
  background-color: var(--ids-dropdown-color-background-selected);
  color: var(--ids-dropdown-color-text-selected);
}

.ids-dropdown {
  display: block;
  position: relative;
}
.ids-dropdown ids-trigger-field[size=full] {
  display: block;
}
.ids-dropdown.full {
  display: block;
}
.ids-dropdown.full ids-trigger-field,
.ids-dropdown.full .ids-trigger-field {
  display: block;
}
.ids-dropdown ::slotted(ids-list-box) {
  height: var(--ids-popup-maxheight);
}

.trigger-icon {
  color: var(--ids-dropdown-color-icon);
  margin: 0 0 0 var(--ids-dropdown-space-text);
  position: relative;
  top: 0;
}

:host([mode=light]) .typeahead.is-open ids-trigger-field::part(field-container) {
  background-color: var(--ids-dropdown-typeahead-color-background);
}

:host([dir=rtl]) .trigger-icon {
  margin: 0 var(--ids-dropdown-space-text) 0 0;
}

::slotted(.sub-group) {
  border-top: 1px solid var(--ids-dropdown-separator-color-border);
  padding-top: var(--ids-dropdown-separator-padding);
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(field-container) {
  margin: 0;
  border-radius: 0;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(label),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(label) {
  display: none;
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(container) {
  margin: -1px;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container) {
  box-shadow: none !important;
}
.ids-dropdown.color-variant-borderless.is-open .ids-trigger-field-slot-trigger-end {
  margin-block-start: 2px;
}
.ids-dropdown.color-variant-borderless.field-height-lg ids-trigger-field::part(input) {
  padding-inline: 12px;
  height: 50px;
}
.ids-dropdown.color-variant-borderless.field-height-lg.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
}
.ids-dropdown.color-variant-borderless.field-height-md ids-trigger-field::part(input) {
  padding-inline: 13px;
  height: 40px;
}
.ids-dropdown.color-variant-borderless.field-height-md.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 10px;
}
.ids-dropdown.color-variant-borderless.field-height-sm ids-trigger-field::part(input) {
  padding-inline: 9px;
  height: 35px;
}
.ids-dropdown.color-variant-borderless.field-height-sm.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
}
.ids-dropdown.color-variant-borderless.field-height-xs ids-trigger-field::part(input) {
  padding-inline: 5px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -2px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs ids-trigger-field::part(input) {
  padding-inline: 3px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  margin-block-start: -2px;
}

:host([combobox]) .ids-dropdown.color-variant-borderless .ids-trigger-field-slot-trigger-end {
  display: flex;
  align-items: center;
  margin-block-start: 2px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-lg .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
  height: 48px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-md .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  height: 39px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-sm .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -5px;
  height: 33px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-xs .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -10px;
  height: 29px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-xxs .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -10px;
  margin-block-start: 0;
}

.ids-dropdown.color-variant-in-cell ids-trigger-field::part(container) {
  margin: 1px 0;
}

.ids-dropdown.color-variant-module-nav {
  color: var(--ids-module-nav-search-input-text-color);
  display: block;
  margin-block-end: 0;
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box-option) {
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(field-container) {
  background-color: var(--ids-module-nav-input-bg-color);
  border-radius: var(--ids-module-nav-common-border-radius);
  border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);
  box-shadow: none;
  color: inherit;
  overflow: hidden;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:hover::part(field-container) {
  background-color: var(--ids-module-nav-input-hover-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:active::part(field-container) {
  background-color: var(--ids-module-nav-item-selected-bg-color);
  border-color: var(--ids-module-nav-item-selected-text-color);
  color: var(--ids-module-nav-item-selected-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:focus-within::part(field-container) {
  background-color: var(--ids-module-nav-input-focus-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input) {
  background-color: var(--ids-color-transparent);
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(trigger-button) {
  background-color: var(--ids-color-transparent);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input::placeholder) {
  color: var(--ids-module-nav-search-input-placeholder-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input:active) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ids-dropdown-list::part(dropdown-list) {
  max-width: var(--ids-module-nav-expanded-size);
  width: calc(var(--ids-module-nav-switcher-dropdown-width) + var(--ids-module-nav-switcher-button-gutter-size) + var(--ids-module-nav-switcher-button-size));
}
.ids-dropdown.color-variant-module-nav ids-list-box-option {
  min-height: var(--ids-module-nav-item-height);
}
.ids-dropdown.color-variant-module-nav .fieldset {
  display: contents;
}
.ids-dropdown.color-variant-module-nav .ids-input-field {
  padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);
}

:host ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=xs]) ids-dropdown-list {
  max-width: var(--ids-input-width-10);
}

:host([size=sm]) ids-dropdown-list {
  max-width: var(--ids-input-width-20);
}

:host([size=mm]) ids-dropdown-list {
  max-width: var(--ids-input-width-30);
}

:host([size=md]) ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=lg]) ids-dropdown-list {
  max-width: var(--ids-input-width-50);
}

:host([size=full]) ids-dropdown-list {
  max-width: var(--ids-input-width-full);
}

:host ids-dropdown-list,
:host([size=full]) {
  width: var(--ids-input-width-full);
}

:host([list]:not([disabled])) {
  cursor: var(--ids-cursor-pointer);
}

:host([auto-size=true]) ids-trigger-field::part(input) {
  padding-inline-end: 0;
}

.ids-dropdown ids-trigger-field::part(clearable-button) {
  margin-inline-end: -6px;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-dropdown/ids-dropdown.scss","webpack://./src/themes/mixins/ids-validation-mixin.scss","webpack://./src/themes/mixins/ids-core-mixins.scss","webpack://./src/themes/mixins/ids-error-tracker-mixin.scss","webpack://./src/themes/mixins/ids-field-indicator-mixin.scss"],"names":[],"mappings":"AAAA,2BAAA;ACEA;ECQE,mCAAA;EACA,kCAAA;EDNA,aAAA;EACA,+EAAA;EACA,gCAAA;EACA,sCAAA;ADAF;ACEE;EACE,oCAAA;ADAJ;ACGE;EACE,2CAAA;ADDJ;ACIE;EACE,uCAAA;ADFJ;ACKE;EACE,uCAAA;ADHJ;ACKI;EACE,iCAAA;ADHN;ACOE;EACE,uCAAA;ADLJ;ACOI;EACE,iCAAA;ADLN;ACSE;EACE,qCAAA;ADPJ;ACSI;EACE,8BAAA;ADPN;ACWE;EACE,oCAAA;ADTJ;ACWI;EACE,+BAAA;ADTN;ACaE;EACE,uCAAA;ADXJ;ACaI;EACE,gCAAA;ADXN;ACeE;EACE,aAAA;ADbJ;;AGjDA;EACE,kBAAA;EACA,+EAAA;EACA,MAAA;EACA,oBAAA;AHoDF;AGlDE;EACE,wBAAA;EACA,MAAA;AHoDJ;;AI5DA;EACE,kBAAA;EACA,MAAA;EACA,oBAAA;AJ+DF;AI7DE;EACE,wBAAA;EACA,MAAA;AJ+DJ;;AI3DA;EACE,yDAAA;EACA,mBAAA;EACA,8EAAA;EACA,eAAA;EACA,sEAAA;AJ8DF;;AI1CA;EAfE,sEAAA;AJ6DF;AIpDE;EACE,2CAAA;AJsDJ;;AI7CA;EAnBE,+DAAA;AJoEF;AI3DE;EACE,oCAAA;AJ6DJ;;AIhDA;EAvBE,kEAAA;AJ2EF;AIlEE;EACE,uCAAA;AJoEJ;;AInDA;EA3BE,kEAAA;AJkFF;AIzEE;EACE,uCAAA;AJ2EJ;;AItDA;EA/BE,kEAAA;AJyFF;AIhFE;EACE,uCAAA;AJkFJ;;AIzDA;EAnCE,gEAAA;AJgGF;AIvFE;EACE,qCAAA;AJyFJ;;AI3DE;EACE,aAAA;AJ8DJ;;AAvHA;EACE,0EAAA;EACA,sEAAA;EACA,4EAAA;EACA,wEAAA;EAEA,cAAA;AAyHF;AAvHE;EACE,qBAAA;EACA,eAAA;EACA,0CAAA;AAyHJ;;AArHA;EACE,oCAAA;AAwHF;;AArHA;;EAEE,2CAAA;AAwHF;;AArHA;EACE,aAAA;AAwHF;;AAlHI;EACE,2DAAA;AAqHN;;AAhHA;EACE,iCAAA;AAmHF;;AA/GE;EACE,8CAAA;AAkHJ;;AA5GI;EACE,+DAAA;EACA,8CAAA;AA+GN;;AAzGA;EACE,cAAA;EACA,kBAAA;AA4GF;AAzGI;EACE,cAAA;AA2GN;AAvGE;EACE,cAAA;AAyGJ;AAvGI;;EAEE,cAAA;AAyGN;AArGE;EACE,kCAAA;AAuGJ;;AAlGA;EACE,qCAAA;EACA,4CAAA;EACA,kBAAA;EACA,MAAA;AAqGF;;AAjGE;EACE,gEAAA;AAoGJ;;AAhGA;EACE,4CAAA;AAmGF;;AAhGA;EACE,gEAAA;EACA,kDAAA;AAmGF;;AA7FE;;EACE,SAAA;EACA,gBAAA;AAiGJ;AA9FE;;EACE,aAAA;AAiGJ;;AA3FE;EACE,YAAA;AA8FJ;AA3FE;EACE,2BAAA;AA6FJ;AAzFI;EACE,uBAAA;AA2FN;AAtFI;EACE,oBAAA;EACA,YAAA;AAwFN;AApFM;EACE,sBAAA;AAsFR;AAhFI;EACE,oBAAA;EACA,YAAA;AAkFN;AA9EM;EACE,uBAAA;AAgFR;AA1EI;EACE,mBAAA;EACA,YAAA;AA4EN;AAxEM;EACE,sBAAA;AA0ER;AApEI;EACE,mBAAA;EACA,YAAA;AAsEN;AAlEM;EACE,uBAAA;AAoER;AA9DI;EACE,mBAAA;EACA,YAAA;AAgEN;AA5DM;EACE,uBAAA;EACA,wBAAA;AA8DR;;AAtDI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAyDN;AArDM;EACE,sBAAA;EACA,YAAA;AAuDR;AAlDM;EACE,uBAAA;EACA,YAAA;AAoDR;AA/CM;EACE,uBAAA;EACA,YAAA;AAiDR;AA5CM;EACE,wBAAA;EACA,YAAA;AA8CR;AAzCM;EACE,wBAAA;EACA,qBAAA;AA2CR;;AAnCE;EACE,aAAA;AAsCJ;;AAjCA;EACE,oDAAA;EACA,cAAA;EACA,mBAAA;AAoCF;AAlCE;EACE,oDAAA;AAoCJ;AAjCE;EACE,cAAA;AAmCJ;AAhCE;EACE,sDAAA;EACA,yDAAA;EACA,+FAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAkCJ;AA/BE;EACE,4DAAA;AAiCJ;AA9BE;EACE,8DAAA;EACA,4DAAA;EACA,qDAAA;AAgCJ;AA7BE;EACE,4DAAA;AA+BJ;AA5BE;EACE,8CAAA;EACA,cAAA;AA8BJ;AA3BE;EACE,8CAAA;AA6BJ;AA1BE;EACE,gEAAA;AA4BJ;AAzBE;EACE,oDAAA;AA2BJ;AAxBE;EACE,8CAAA;EACA,2JAAA;AA0BJ;AAvBE;EACE,6CAAA;AAyBJ;AAtBE;EACE,iBAAA;AAwBJ;AArBE;EACE,8EAAA;AAuBJ;;AAlBA;EACE,oCAAA;AAqBF;;AAlBA;EACE,oCAAA;AAqBF;;AAlBA;EACE,oCAAA;AAqBF;;AAlBA;EACE,oCAAA;AAqBF;;AAlBA;EACE,oCAAA;AAqBF;;AAlBA;EACE,oCAAA;AAqBF;;AAlBA;EACE,sCAAA;AAqBF;;AAlBA;;EAEE,kCAAA;AAqBF;;AAjBA;EACE,iCAAA;AAoBF;;AAhBE;EACE,qBAAA;AAmBJ;;AAfA;EACE,uBAAA;AAkBF","sourcesContent":["/* Ids Dropdown Component */\n@use '../../themes/mixins/ids-validation-mixin';\n@use '../../themes/mixins/ids-core-mixins' as *;\n@use '../../themes/mixins/ids-error-tracker-mixin' as *;\n@use '../../themes/mixins/ids-field-indicator-mixin' as *;\n\n:host {\n  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n  --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);\n  --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);\n  --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);\n\n  display: block;\n\n  .ids-dropdown {\n    display: inline-block;\n    max-width: 100%;\n    width: var(--ids-box-dropdown-width, auto);\n  }\n}\n\n:host([field-indicator]) {\n  --ids-field-indicator-info-margin: 0;\n}\n\n:host([field-indicator][readonly]),\n:host([field-indicator][disabled]) {\n  --ids-field-indicator-info-visibility: none;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n\n:host([label-position=\"inline-start\"]) {\n  ids-trigger-field {\n    &::part(container) {\n      justify-content: var(--ids-box-justify-content, flex-start);\n    }\n  }\n}\n\nids-trigger-field[readonly-background]:not([disabled])::part(input) {\n  cursor: var(--ids-cursor-pointer);\n}\n\nids-trigger-field:not([autoselect])::part(input) {\n  &::selection {\n    background-color: var(--ids-color-transparent);\n  }\n}\n\n.ids-dropdown.is-open {\n  ids-trigger-field:not([autoselect])::part(input) {\n    &::selection {\n      background-color: var(--ids-dropdown-color-background-selected);\n      color: var(--ids-dropdown-color-text-selected);\n    }\n  }\n}\n\n// Most Styles are in list-box, popup and trigger field\n.ids-dropdown {\n  display: block;\n  position: relative;\n\n  ids-trigger-field {\n    &[size='full'] {\n      display: block;\n    }\n  }\n\n  &.full {\n    display: block;\n\n    ids-trigger-field,\n    .ids-trigger-field {\n      display: block;\n    }\n  }\n\n  ::slotted(ids-list-box) {\n    height: var(--ids-popup-maxheight);\n  }\n}\n\n// Icon Placement\n.trigger-icon {\n  color: var(--ids-dropdown-color-icon);\n  margin: 0 0 0 var(--ids-dropdown-space-text);\n  position: relative;\n  top: 0;\n}\n\n:host([mode='light']) {\n  .typeahead.is-open ids-trigger-field::part(field-container) {\n    background-color: var(--ids-dropdown-typeahead-color-background);\n  }\n}\n\n:host([dir='rtl']) .trigger-icon {\n  margin: 0 var(--ids-dropdown-space-text) 0 0;\n}\n\n::slotted(.sub-group) {\n  border-top: 1px solid var(--ids-dropdown-separator-color-border);\n  padding-top: var(--ids-dropdown-separator-padding);\n}\n\n// Dropdown Editor\n.ids-dropdown.color-variant-borderless,\n.ids-dropdown.color-variant-in-cell {\n  ids-trigger-field::part(field-container) {\n    margin: 0;\n    border-radius: 0;\n  }\n\n  ids-trigger-field::part(label) {\n    display: none;\n  }\n}\n\n// Dropdown Editor Borderless\n.ids-dropdown.color-variant-borderless {\n  ids-trigger-field::part(container) {\n    margin: -1px;\n  }\n\n  ids-trigger-field::part(field-container) {\n    box-shadow: none !important;\n  }\n\n  &.is-open {\n    .ids-trigger-field-slot-trigger-end {\n      margin-block-start: 2px;\n    }\n  }\n\n  &.field-height-lg {\n    ids-trigger-field::part(input) {\n      padding-inline: 12px;\n      height: 50px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 3px;\n      }\n    }\n  }\n\n  &.field-height-md {\n    ids-trigger-field::part(input) {\n      padding-inline: 13px;\n      height: 40px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 10px;\n      }\n    }\n  }\n\n  &.field-height-sm {\n    ids-trigger-field::part(input) {\n      padding-inline: 9px;\n      height: 35px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 3px;\n      }\n    }\n  }\n\n  &.field-height-xs {\n    ids-trigger-field::part(input) {\n      padding-inline: 5px;\n      height: 30px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -2px;\n      }\n    }\n  }\n\n  &.field-height-xxs {\n    ids-trigger-field::part(input) {\n      padding-inline: 3px;\n      height: 30px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -1px;\n        margin-block-start: -2px;\n      }\n    }\n  }\n}\n\n:host([combobox]) {\n  .ids-dropdown.color-variant-borderless {\n    .ids-trigger-field-slot-trigger-end {\n      display: flex;\n      align-items: center;\n      margin-block-start: 2px;\n    }\n\n    &.field-height-lg {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 3px;\n        height: 48px;\n      }\n    }\n\n    &.field-height-md {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -1px;\n        height: 39px;\n      }\n    }\n\n    &.field-height-sm {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -5px;\n        height: 33px;\n      }\n    }\n\n    &.field-height-xs {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -10px;\n        height: 29px;\n      }\n    }\n\n    &.field-height-xxs {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -10px;\n        margin-block-start: 0;\n      }\n    }\n  }\n}\n\n// Dropdown Editor In Cell\n.ids-dropdown.color-variant-in-cell {\n  ids-trigger-field::part(container) {\n    margin: 1px 0;\n  }\n}\n\n// Module Nav Color Variant\n.ids-dropdown.color-variant-module-nav {\n  color: var(--ids-module-nav-search-input-text-color);\n  display: block;\n  margin-block-end: 0;\n\n  ::slotted(ids-list-box) {\n    color: var(--ids-module-nav-search-input-text-color);\n  }\n\n  ::slotted(ids-list-box-option) {\n    color: inherit;\n  }\n\n  ids-trigger-field::part(field-container) {\n    background-color: var(--ids-module-nav-input-bg-color);\n    border-radius: var(--ids-module-nav-common-border-radius);\n    border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);\n    box-shadow: none;\n    color: inherit;\n    overflow: hidden;\n  }\n\n  ids-trigger-field:hover::part(field-container) {\n    background-color: var(--ids-module-nav-input-hover-bg-color);\n  }\n\n  ids-trigger-field:active::part(field-container) {\n    background-color: var(--ids-module-nav-item-selected-bg-color);\n    border-color: var(--ids-module-nav-item-selected-text-color);\n    color: var(--ids-module-nav-item-selected-text-color);\n  }\n\n  ids-trigger-field:focus-within::part(field-container) {\n    background-color: var(--ids-module-nav-input-focus-bg-color);\n  }\n\n  ids-trigger-field::part(input) {\n    background-color: var(--ids-color-transparent);\n    color: inherit;\n  }\n\n  ids-trigger-field::part(trigger-button) {\n    background-color: var(--ids-color-transparent);\n  }\n\n  ids-trigger-field::part(input::placeholder) {\n    color: var(--ids-module-nav-search-input-placeholder-text-color);\n  }\n\n  ids-trigger-field::part(input:active) {\n    color: var(--ids-module-nav-search-input-text-color);\n  }\n\n  ids-dropdown-list::part(dropdown-list) {\n    max-width: var(--ids-module-nav-expanded-size);\n    width: calc(var(--ids-module-nav-switcher-dropdown-width) + var(--ids-module-nav-switcher-button-gutter-size) + var(--ids-module-nav-switcher-button-size));\n  }\n\n  ids-list-box-option {\n    min-height: var(--ids-module-nav-item-height);\n  }\n\n  .fieldset {\n    display: contents;\n  }\n\n  .ids-input-field {\n    padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);\n  }\n}\n\n// Dropdown menu width\n:host ids-dropdown-list {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='xs']) ids-dropdown-list {\n  max-width: var(--ids-input-width-10);\n}\n\n:host([size='sm']) ids-dropdown-list {\n  max-width: var(--ids-input-width-20);\n}\n\n:host([size='mm']) ids-dropdown-list {\n  max-width: var(--ids-input-width-30);\n}\n\n:host([size='md']) ids-dropdown-list {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='lg']) ids-dropdown-list {\n  max-width: var(--ids-input-width-50);\n}\n\n:host([size='full']) ids-dropdown-list {\n  max-width: var(--ids-input-width-full);\n}\n\n:host ids-dropdown-list,\n:host([size='full']) {\n  width: var(--ids-input-width-full);\n}\n\n// Change state for external dropdown list\n:host([list]:not([disabled])) {\n  cursor: var(--ids-cursor-pointer);\n}\n\n:host([auto-size=\"true\"]) {\n  ids-trigger-field::part(input) {\n    padding-inline-end: 0;\n  }\n}\n\n.ids-dropdown ids-trigger-field::part(clearable-button) {\n  margin-inline-end: -6px;\n}\n","@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n.validation-message {\n  @include mixins.antialiased();\n\n  display: flex;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  margin-top: var(--ids-space-2xs);\n  max-width: var(--ids-input-width-full);\n\n  &.has-custom-icon {\n    color: var(--ids-icon-color-default);\n  }\n\n  &.disabled {\n    color: var(--ids-input-color-text-disabled);\n  }\n\n  .ids-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  &.alert {\n    color: var(--ids-color-caution-default);\n\n    &.disabled {\n      color: var(--ids-color-yellow-30);\n    }\n  }\n\n  &.warning {\n    color: var(--ids-color-warning-default);\n\n    &.disabled {\n      color: var(--ids-color-orange-30);\n    }\n  }\n\n  &.error {\n    color: var(--ids-color-error-default);\n\n    &.disabled {\n      color: var(--ids-color-red-30);\n    }\n  }\n\n  &.info {\n    color: var(--ids-color-info-default);\n\n    &.disabled {\n      color: var(--ids-color-blue-30);\n    }\n  }\n\n  &.success {\n    color: var(--ids-color-success-default);\n\n    &.disabled {\n      color: var(--ids-color-green-30);\n    }\n  }\n\n  &[hidden] {\n    display: none;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 2463px;\n$breakpoint-xl: 1183px;\n$breakpoint-lg: 928px;\n$breakpoint-md: 927px;\n$breakpoint-sm: 767px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  /* stylelint-disable-next-line property-no-deprecated */\n  clip: rect(0, 0, 0, 0);\n  color: var(--ids-color-text-default);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n","// General Error-Tracker icon placement\n.icon-error-tracker {\n  position: absolute;\n  color: var(--ids-input-error-tracker-color-background, var(--ids-color-red-60));\n  top: 0;\n  pointer-events: none;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n}\n","// Field Indicator icon placement\n.icon-field-indicator {\n  position: absolute;\n  top: 0;\n  pointer-events: none;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n}\n\n.icon-field-indicator-info {\n  display: var(--ids-field-indicator-info-visibility, flex);\n  align-items: center;\n  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));\n  cursor: pointer;\n  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);\n}\n\n// Mixin to apply field indicator color variables\n@mixin field-indicator-color($color, $border-color: null) {\n  --ids-field-indicator-icon-color: #{$color};\n\n  @if $border-color {\n    --ids-input-border-default-color: #{$border-color};\n    --ids-input-color-border-hover: #{$border-color};\n    --ids-input-color-border-disabled: #{$border-color};\n    --ids-input-color-border-focus: #{$border-color};\n  }\n\n  .icon-field-indicator {\n    color: #{$color};\n  }\n}\n\n// Field indicator type classes — applied to the field container.\n.field-indicator-neutral {\n  @include field-indicator-color(var(--ids-color-accent-neutral-weak));\n}\n\n.field-indicator-info {\n  @include field-indicator-color(var(--ids-color-info-default));\n}\n\n.field-indicator-success {\n  @include field-indicator-color(var(--ids-color-success-default));\n}\n\n.field-indicator-caution {\n  @include field-indicator-color(var(--ids-color-caution-default));\n}\n\n.field-indicator-warning {\n  @include field-indicator-color(var(--ids-color-warning-default));\n}\n\n.field-indicator-error {\n  @include field-indicator-color(var(--ids-color-error-default));\n}\n\n[class*=\"field-indicator-\"].has-focus {\n  .icon-field-indicator-info {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
